import PropTypes from 'prop-types'
import React from 'react'

import Cost, { CostPreloader } from 'components/Cost'

import {
  CrossedCostBlock,
  CostBlock,
  MutedCostBox,
  PriceWrapper,
} from './styles'

/**
 * CartCostBlock
 *
 * @param {object} props - properties of component
 * @returns {node} CartCostBlock
 */
const CartEmptyCostBlockNew = props => {
  const {
    intlCode,
    currencyCode,
    realCost,
    cost,
    isLoading,
    showCrossedCost,
    precision,
    size,
    inRow,
  } = props

  return (
    <>
      <PriceWrapper inRow={inRow}>
        <CostBlock>
          {isLoading ? (
            <CostPreloader size={size} />
          ) : (
            <Cost
              value={cost}
              intlCode={intlCode}
              currency={currencyCode}
              size={size}
              precision={precision}
            />
          )}
        </CostBlock>
        {showCrossedCost && (
          <CrossedCostBlock>
            <MutedCostBox>
              {isLoading ? (
                <CostPreloader size={'base'} />
              ) : (
                <Cost
                  value={realCost}
                  intlCode={intlCode}
                  currency={currencyCode}
                  size={'base'}
                  strikethrough={true}
                  precision={precision}
                />
              )}
            </MutedCostBox>
          </CrossedCostBlock>
        )}
      </PriceWrapper>
    </>
  )
}

CartEmptyCostBlockNew.propTypes = {
  cost: PropTypes.number.isRequired,
  currencyCode: PropTypes.string.isRequired,
  intlCode: PropTypes.string.isRequired,
  realCost: PropTypes.number.isRequired,
  showCrossedCost: PropTypes.bool.isRequired,
  precision: PropTypes.number,
  isLoading: PropTypes.bool,
  size: PropTypes.string,
  inRow: PropTypes.bool,
}

CartEmptyCostBlockNew.defaultProps = {
  size: 'cart',
  inRow: false,
}

export default CartEmptyCostBlockNew
